// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__ZmJ_o","load1":"Spinner_load1__iWBPg"};